"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _hex2rgba = _interopRequireDefault(require("../../utils/hex2rgba"));

var _primary = _interopRequireDefault(require("./primary.style"));

var _secondary = _interopRequireDefault(require("./secondary.style"));

var _danger = _interopRequireDefault(require("./danger.style"));

var _link = _interopRequireDefault(require("./link.style")); // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var INNER_BORDER_WIDTH = '2px';

var getPadding = function getPadding(p) {
  var _p$theme$tokens = p.theme.tokens,
      spacing02 = _p$theme$tokens.spacing02,
      spacing03 = _p$theme$tokens.spacing03,
      spacing04 = _p$theme$tokens.spacing04,
      spacing05 = _p$theme$tokens.spacing05;
  return p.size === 'small' ? "".concat(spacing02, " ").concat(spacing03) : "calc(".concat(spacing04, " - ").concat(INNER_BORDER_WIDTH, ") calc(").concat(spacing05, " - ").concat(INNER_BORDER_WIDTH, ")");
};

var Button = /*#__PURE__*/_styledComponents["default"].button.attrs(function (p) {
  // Transform link types to button when disabled to prevent unwanted browser behaviour
  if (p.disabled && ('href' in p || 'to' in p)) {
    return {
      as: 'button'
    };
  }
}).withConfig({
  displayName: "Button",
  componentId: "sc-g50bbf-0"
})(["display:inline-flex;align-items:center;justify-content:center;position:relative;padding:", ";min-width:", ";min-height:", ";border:", " solid transparent;vertical-align:middle;font-size:", ";font-weight:", ";line-height:", ";text-align:center;text-decoration:none;cursor:", ";user-select:none;&:after{background-color:", ";content:'';position:absolute;height:3px;bottom:-", ";left:-", ";right:-", ";}&:focus{border:", " solid ", ";outline:", " solid ", ";&:after{display:none;}}", ""], function (p) {
  return getPadding(p);
}, function (p) {
  return p.size === 'small' ? '2.25rem' : p.theme.tokens.spacing09;
}, function (p) {
  return p.size === 'small' ? '2.25rem' : p.theme.tokens.spacing09;
}, INNER_BORDER_WIDTH, function (p) {
  return p.theme.tokens.fontSizeMedium;
}, function (p) {
  return p.theme.tokens.fontWeightSemiBold;
}, function (p) {
  return p.theme.tokens.lineHeightText;
}, function (p) {
  return p.disabled ? 'not-allowed' : 'pointer';
}, function (p) {
  return (0, _hex2rgba["default"])(p.theme.tokens.colorPaletteGray900, 0.25);
}, INNER_BORDER_WIDTH, INNER_BORDER_WIDTH, INNER_BORDER_WIDTH, INNER_BORDER_WIDTH, function (p) {
  return p.theme.tokens.colorBackground;
}, INNER_BORDER_WIDTH, function (p) {
  return p.theme.tokens.colorFocus;
}, function (p) {
  switch (p.variant) {
    case 'link':
      return (0, _link["default"])(p);

    case 'danger':
      return (0, _danger["default"])(p);

    case 'secondary':
      return (0, _secondary["default"])(p);

    case 'primary':
    default:
      return (0, _primary["default"])(p);
  }
});

Button.propTypes = {
  variant: (0, _propTypes.oneOf)(['primary', 'secondary', 'danger', 'link']),
  disabled: _propTypes.bool,
  size: (0, _propTypes.oneOf)(['small', 'default'])
};
Button.defaultProps = {
  variant: 'primary',
  disabled: false,
  size: 'default'
};
var _default = Button;
exports["default"] = _default;